/** The running-stamina gauge as the server last sent it, stamped with when
 *  it arrived (`Stamina` frame, `char.cpp:5631-5651`). */
export interface Stamina_ {
  readonly stamina: number;
  readonly maxStamina: number;
  /** Points a second the gauge falls while the server charges a run. */
  readonly consumePerSec: number;
  /** `performance.now()` when the frame arrived. */
  readonly atMs: number;
}

export const NO_STAMINA: Stamina_ = { stamina: 0, maxStamina: 0, consumePerSec: 0, atMs: 0 };

/** The value the gauge draws at `nowMs`: `CPythonPlayer::Update` takes
 *  `elapsed * m_fConsumeStaminaPerSec` off the last sent stamina every frame
 *  (`PythonPlayer.cpp:169-175`), floored at zero because the server walks the
 *  runner there (`char_state.cpp:814-819`). */
export function staminaAt(gauge: Stamina_, nowMs: number): number {
  const spent = (gauge.consumePerSec * Math.max(0, nowMs - gauge.atMs)) / 1000;
  return Math.max(0, Math.floor(gauge.stamina - spent));
}
